import { WelcomePage } from '@Pages/welcome';

export const public_routes = [
    {
        path: '/welcome',
        element: <WelcomePage />,
    },
];
